import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import { Menu, MenuItem, Button, ListItemIcon, makeStyles, } from '@material-ui/core';
import clsx from 'clsx';
import { useDropdown, } from '../..';
const useStyle = makeStyles((theme) => {
    return {
        root: {
            overflow: 'hidden',
            position: 'relative',
        },
        toolBar: {},
        title: {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            textShadow: '2px 2px 1px rgba(0, 0, 0, 0.3)',
            display: 'none',
            marginRight: theme.spacing(1),
            '& button': {
                color: 'unset',
                textTransform: 'none',
                fontSize: 'unset',
                fontWeight: 'unset',
                padding: 0,
            },
            [theme.breakpoints.up('sm')]: {
                display: 'block',
                marginRight: theme.spacing(2),
            },
        },
        languageSelector: {},
        leftContent: {
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            justifyContent: 'flex-end',
        },
        loginButton: {
            marginLeft: theme.spacing(1),
        },
        profileMenu: {
            marginLeft: theme.spacing(1),
        },
        profileMenuNameAndRole: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            textAlign: 'right',
            position: 'relative',
        },
        profileMenuName: {
            lineHeight: '1em',
            textTransform: 'none',
        },
        profileMenuRole: {
            lineHeight: '1em',
            fontSize: '0.7em',
            paddingTop: 2,
            flex: 1,
            width: '100%',
            position: 'absolute',
            top: -12,
            right: 0,
            fontStyle: 'italic',
        },
        profileMenuIconAvatar: {
            width: '1.5em',
            height: '1.5em',
            borderRadius: '50%',
            border: '1px solid #ffffff',
        },
        profileMenuIconDefault: {
            textShadow: '2px 2px 1px rgba(0, 0, 0, 0.3)',
        },
        profileMenuItemIcon: {
            minWidth: 'unset',
            marginRight: theme.spacing(1),
        },
    };
}, {
    name: 'TopNavBar',
});
export const TopNavBar = (props) => {
    const [profileMenuAnchorEl, isProfileMenuOpened, onProfileMenuAnchorClicked, onProfileMenuClosed] = useDropdown();
    const classes = useStyle();
    /**
     * Create the dropdown menu for the agent's profile.
     */
    const renderProfileMenu = (profileMenu) => {
        const avatar = profileMenu.avatar
            ? (_jsx("img", { className: classes.profileMenuIconAvatar, src: profileMenu.avatar, alt: profileMenu.avatar }))
            : _jsx(Icon, { className: classes.profileMenuIconDefault, fontSize: "large", children: "account_circle" });
        return (_jsxs("div", { className: classes.profileMenu, children: [_jsx(Button, { onClick: onProfileMenuAnchorClicked, color: "inherit", startIcon: avatar, endIcon: _jsx(Icon, { children: "arrow_drop_down" }), children: _jsxs("div", { className: classes.profileMenuNameAndRole, children: [profileMenu.role && (_jsx("div", { className: classes.profileMenuRole, children: profileMenu.role })), _jsx("div", { className: classes.profileMenuName, children: profileMenu.name ? profileMenu.name : '' })] }) }), _jsx(Menu, { getContentAnchorEl: null, anchorEl: profileMenuAnchorEl, keepMounted: true, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right',
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    }, open: isProfileMenuOpened, onClose: onProfileMenuClosed, children: profileMenu.menuItems.filter((item) => {
                        return !item.hidden;
                    }).map((item) => {
                        return (_jsxs(MenuItem, { onClick: () => {
                                onProfileMenuClosed();
                                profileMenu.onProfileMenuItemClicked(item.id);
                            }, children: [_jsx(ListItemIcon, { className: classes.profileMenuItemIcon, children: _jsx(Icon, { children: item.icon }) }), item.label] }, item.id));
                    }) })] }));
    };
    return (_jsxs(AppBar, { className: clsx(classes.root, props.className), style: props.style, children: [_jsxs(Toolbar, { className: classes.toolBar, children: [props.drawerMenuTogglerComp, _jsx(Typography, { variant: "h6", className: classes.title, children: _jsx(Button, { variant: "text", onClick: props.onGoHomeClicked, children: props.title }) }), _jsxs("div", { className: classes.leftContent, children: [props.languageSelectorComp, props.profileMenu
                                ? (renderProfileMenu(props.profileMenu))
                                : (_jsx(Button, { variant: "contained", className: classes.loginButton, onClick: props.onLoginClicked, children: props.loginLabel }))] })] }), props.breadcrumbsBarComp, props.subRouteNavBarComp, props.controlBarComp] }));
};
